import PipesPage from '@/pages/PipesPage/PipesPage';
export default PipesPage;
